import script from "./VehicleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleForm.vue?vue&type=script&setup=true&lang=js"

import "./VehicleForm.vue?vue&type=style&index=0&id=ef2529fc&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef2529fc"]])

export default __exports__